import _ from 'lodash'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Drawer, List, ListItem } from '@material-ui/core'
import I18n from '../lib/i18n'
import IconCaretLeft from '../images/icon_caret_left.svg'
import IconCaretRight from '../images/icon_caret_right.svg'
import IconCrossDark from '../images/icon_cross_dark.svg'
import * as StyledComponent from '../styles'

class DrawerMenu extends Component {
  constructor(props) {
    super(props)
    this.state = this.getInitialState()
  }

  getInitialState = () => ({ deparments: {}, is_cat_menu_open: false })

  toggleMenu = (menu) => () => {
    const is_cat_menu_open = !!!this.state.deparments[menu]
    this.setState({
      deparments: { [menu]: is_cat_menu_open },
      is_cat_menu_open
    })
  }

  goToSearchResult = (category_code) => () => {
    this.closeDrawer()
    this.props.history.push(`/${I18n.currentLocale()}/search?category_code_eq=${encodeURIComponent(category_code)}`)
  }

  goToProductGroups = () => {
    this.props.history.push(`/${I18n.currentLocale()}/products`)
    this.props.toggleDrawer()
  }

  closeDrawer = () => {
    this.setState(this.getInitialState())
    this.props.toggleDrawer()
  }

  render() {
    const { departments = [], open } = this.props
    const { is_cat_menu_open } = this.state

    return <Drawer className='drawer' open={open} onClose={this.closeDrawer}>
      <StyledComponent.DrawerMenu>
        <List className={`menu-list dep-menu-list ${is_cat_menu_open ? 'hide' : ''}`}>
          <div className='dep-header'>
            <img className='close-menu' src={IconCrossDark} alt='' onClick={this.props.toggleDrawer} />
          </div>
          <ListItem className='dep-name' onClick={this.goToProductGroups}>
            { I18n.t('menu_list.home') }
          </ListItem>
          {
            departments.map(department => <ListItem
              className='dep-name'
              key={`dep-${department.code}`}
              onClick={this.toggleMenu(department.code)}
            >
              { department.name }
              <img className='caret' src={IconCaretRight} alt='' />
            </ListItem>)
          }
        </List>
        {
          departments.map(department => <List
            className={`menu-list cat-menu-list cat-container ${!!this.state.deparments[department.code] ? 'show' : ''}`}
            key={`cat-container-${department.code}`}
          >
            <div className='dep-title'>
              <img className='caret' src={IconCaretLeft} alt='' onClick={this.toggleMenu(department.code)} />
              <span>{ department.name }</span>
              <img className='close-menu' src={IconCrossDark} alt='' onClick={this.closeDrawer} />
            </div>
            {
              department.categories.map(category => <div key={`cat-${category.code}`} className='cat-list'>
                {
                  _.isEmpty(category.children)
                    ? <ListItem className='cat-title' onClick={this.goToSearchResult(category.code)}>
                        { category.name }
                      </ListItem>
                    : <ListItem
                        className='cat-title'
                      >
                        { category.name }
                      </ListItem>
                }
                {
                  category.children.map(sub_category => <ListItem
                    className='sub-cat-name'
                    key={`sub-cat-${sub_category.code}`}
                    onClick={this.goToSearchResult(sub_category.code)}
                  >
                    { sub_category.name }
                  </ListItem>)
                }
                {
                  !_.isEmpty(category.children) &&
                    <ListItem
                      className='sub-cat-name'
                      onClick={this.goToSearchResult(category.code)}
                    >
                      {I18n.t('menu_list.all', { category: category.name})}
                    </ListItem>
                }
              </div>)
            }
          </List>)
        }
      </StyledComponent.DrawerMenu>
    </Drawer>
  }
}

export default withRouter(DrawerMenu)



// WEBPACK FOOTER //
// ./src/containers/DrawerMenu.js